import { useAuthStore } from "../store/authStore.js";
import { canAccess } from "./planGate.js";

/**
 * Returns the active workspace's plan name ("standard" | "professional"),
 * defaulting to "standard" when unknown.
 */
export function usePlan() {
  return useAuthStore((s) => s.workspace?.plan) ?? "standard";
}

/**
 * Returns a memoized `allows(feature)` predicate for the active plan.
 *
 *   const allows = usePlanGate();
 *   if (allows("api_keys")) { ... }
 */
export function usePlanGate() {
  const plan = usePlan();
  return (feature) => canAccess(feature, plan);
}
